import $http from "../../axios";
import { Notification } from "element-ui";

export async function generateSquareCashRegisterPdf({ commit, state }) {
  commit("setLoadingPdf", true);
  commit("resetFileNamePdfCashRegisterSquare");

  var params = {
    params: state.paramsGeneratePdf
  };

  $http
    .get("/api/cuadre-de-caja", params)
    .then(response => {
        if(response.data === 'No hay registros para esta caja'){
            Notification.success({
                title: "¡success!",
                message: "No hay registros para esta caja en las fechas seleccionadas",
                type: "success",
                duration: 3500,
                customClass: "notification-box"
            });
        }else{
            commit("setFileNamePdfCashRegisterSquare", response.data);
            commit("setShowPdfCashRegisterSquare", true);
        }

      commit("setLoadingPdf", false);
    })
    .catch(error => {
      commit("setLoadingPdf", false);
      Notification.error({
        title: "¡Error!",
        message: "Error al crear el cuadre de caja.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function saveSquareCashRegister({ commit, state, dispatch }) {
  await $http
    .post("/api/historial-cuadre-de-caja", state.paramsGeneratePdf)
    .then(response => {
      commit("resetFileNamePdfCashRegisterSquare");
      dispatch("getHistorySquareCashRegister");
    })
    .catch(error => {
      Notification.error({
        title: "¡Error!",
        message: "Error al crear el cuadre de caja.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function updateSquareCashRegister(
  { commit, state, dispatch },
  id
) {
  await $http
    .put(`/api/historial-cuadre-de-caja/${id}`, state.paramsGeneratePdf)
    .then(response => {
      commit("resetFileNamePdfCashRegisterSquare");
      dispatch("getHistorySquareCashRegister");
    })
    .catch(error => {
      Notification.error({
        title: "¡Error!",
        message: "Error al crear el cuadre de caja.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function getHistorySquareCashRegister({ commit, state }) {
  var params = {
    params: state.paramsHistoryTable
  };
  $http
    .get("/api/historial-cuadre-de-caja", params)
    .then(response => {
      commit("setItemsHistoryTable", response.data);
    })
    .catch(error => {
      state.loading.module = false
      console.error(error);
      Notification.error({
        title: "¡Error!",
        message: "Error al traer los cuadres de caja.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function deleteHistorySquareCashRegister(
  { commit, state, dispatch },
  id
) {
  await $http
    .delete(`/api/historial-cuadre-de-caja/${id}`)
    .then(response => {
      dispatch("getHistorySquareCashRegister");
    })
    .catch(error => {
      Notification.error({
        title: "¡Error!",
        message: "Error al eliminar el cuadre de caja.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function fetchCashRegisters({commit, state}, ) {
    await $http
        .get("/api/parametros-por-codigo/081")
        .then(response => {
            commit("setCashRegisters", response.data.data);
        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}
export async function getPaymentMethods({commit, state}) {
    await $http
        .get(`/api/get-formas-pago`)
        .then(response => {
            commit('setPaymentMethods', response.data.data);
        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box'
            });
        });
}

export async function generateSuccessSalesReport({ commit, state }, params) {
    try {

        const response = await $http.get(
            '/api/generate-success-sales-report',
            {
                params,
                responseType: 'blob'
            }
        );

        const contentType = response.headers['content-type'];

        let extension = 'xlsx';

        if (contentType.includes('pdf')) {
            extension = 'pdf';
        }

        const blob = new Blob([response.data], {
            type: contentType
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');

        const startDate = params.start_date.replaceAll('-', '');
        const endDate = params.end_date.replaceAll('-', '');

        link.href = url;
        link.download = `informe_ventas_concesiones_${startDate}_${endDate}.${extension}`;

        document.body.appendChild(link);

        link.click();

        link.remove();

        window.URL.revokeObjectURL(url);

        Notification.success({
            title: 'Correcto!',
            message: 'Reporte generado correctamente',
            type: 'success',
            duration: 2000,
            customClass: 'notification-box'
        });

    } catch (error) {

        Notification.error({
            title: 'Error!',
            message: 'No fue posible generar el reporte',
            type: 'error',
            duration: 2000,
            customClass: 'notification-box'
        });
    }
}


// WEBPACK FOOTER //
// ./src/modules/cash-register-square/actions.js